import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Select from "react-select";

import classNames from "classnames";

import { useScheduleActionsContext } from "../contexts/ScheduleActions";

import { selectField } from "../../../../../features/global/globalSlice";
import { selectSelectedTournament } from "../../../../../features/tourneymgmt/tournamentManagementSlice";
import { useAppSelector } from "../../../../../hooks/reduxHooks";
import { IMasterTournament } from "../../../../../types/api";

const MoveGames = (): React.JSX.Element => {
    const tournament = useAppSelector(
        selectSelectedTournament,
    ) as IMasterTournament;
    const field = useAppSelector(state =>
        selectField(state, tournament.field.id),
    );

    const {
        moveGamesFromField,
        setMoveGamesFromField,
        moveGamesToField,
        setMoveGamesToField,
        daysToMove,
        setDaysToMove,
        schedule,
        moveGamesDays,
        setMoveGamesDays,
    } = useScheduleActionsContext();

    return (
        <React.Fragment>
            <Row className={classNames("border-top", "pt-2")}>
                <Col>
                    <h4>Move Games to another Field</h4>
                    <p>
                        Use this to move <b>all</b> of a day's games from one
                        field to another. Select the "From" field, select the
                        day's games you want to move (or all days), then the
                        games (or all games), and then select the "To" field.
                        All games selected will be moved from the "From" field
                        to the "To" field. All game days and times will remain
                        the same, this will <b>only</b> change the game's field.
                        This may result in "doubling-up" of games so please
                        review the{" "}
                        <Link
                            to={`/tournament-management/tournament/${tournament.id}/calendar`}
                        >
                            Calendar
                        </Link>{" "}
                        after making your changes.
                    </p>
                </Col>
            </Row>
            <Row className={classNames("border-bottom", "pb-2")}>
                <Col xs={3}>
                    <h5>From:</h5>
                    <Select
                        isMulti={false}
                        isSearchable={false}
                        isClearable={false}
                        value={
                            moveGamesFromField
                                ? {
                                      value: moveGamesFromField,
                                      label: field?.diamonds.find(
                                          d => d.id === moveGamesFromField,
                                      )?.name,
                                  }
                                : null
                        }
                        options={field?.diamonds
                            .filter(d => {
                                return moveGamesToField
                                    ? d.id !== moveGamesToField
                                    : d;
                            })
                            .map(d => ({
                                value: d.id,
                                label: d.name,
                            }))}
                        onChange={f => {
                            if (f) {
                                setMoveGamesFromField(f.value);
                                setDaysToMove([]);
                                setMoveGamesDays(() => {
                                    return Array.from(
                                        new Set(
                                            schedule.games
                                                .flatMap(
                                                    ageLevels =>
                                                        ageLevels.games || [],
                                                )
                                                .filter(
                                                    g => g.diamond === f.value,
                                                )
                                                .map(game =>
                                                    new Date(
                                                        game.date,
                                                    ).toLocaleDateString(
                                                        "en-US",
                                                        {
                                                            dateStyle: "short",
                                                        },
                                                    ),
                                                ),
                                        ),
                                    );
                                });
                            }
                        }}
                    />
                </Col>
                <Col xs={6}>
                    {moveGamesDays.length ? (
                        <React.Fragment>
                            <h5>Select Days</h5>
                            <Select
                                isMulti={true}
                                isSearchable={false}
                                isClearable={true}
                                value={daysToMove.map(d => ({
                                    value: d,
                                    label: new Date(d).toLocaleDateString(
                                        "en-US",
                                        { weekday: "long" },
                                    ),
                                }))}
                                options={moveGamesDays?.map(d => {
                                    return {
                                        value: d,
                                        label: new Date(d).toLocaleDateString(
                                            "en-US",
                                            {
                                                weekday: "long",
                                            },
                                        ),
                                    };
                                })}
                                onChange={d => {
                                    setDaysToMove(d.map(day => day.value));
                                }}
                            />
                        </React.Fragment>
                    ) : (
                        <></>
                    )}
                </Col>
                <Col xs={3}>
                    {daysToMove.length !== 0 && (
                        <React.Fragment>
                            <h5>To:</h5>
                            <Select
                                isMulti={false}
                                isSearchable={false}
                                isClearable={false}
                                value={
                                    moveGamesToField
                                        ? {
                                              value: moveGamesToField,
                                              label: field?.diamonds.find(
                                                  d =>
                                                      d.id === moveGamesToField,
                                              )?.name,
                                          }
                                        : null
                                }
                                options={field?.diamonds
                                    .filter(d => {
                                        return moveGamesFromField
                                            ? moveGamesFromField != d.id
                                            : d;
                                    })
                                    .map(d => ({
                                        value: d.id,
                                        label: d.name,
                                    }))}
                                onChange={f =>
                                    f && setMoveGamesToField(f.value)
                                }
                            />
                        </React.Fragment>
                    )}
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default MoveGames;
